var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1875 12.875C2 12.875 0.25 11.125 0.25 8.9375C0.25 7.24219 1.34375 5.76562 2.875 5.24609C2.875 5.16406 2.875 5.08203 2.875 5C2.875 2.59375 4.81641 0.625 7.25 0.625C8.86328 0.625 10.2852 1.52734 11.0234 2.83984C11.4336 2.53906 11.9531 2.375 12.5 2.375C13.9492 2.375 15.125 3.55078 15.125 5C15.125 5.35547 15.043 5.65625 14.9336 5.95703C16.5469 6.28516 17.75 7.70703 17.75 9.375C17.75 11.3164 16.1641 12.875 14.25 12.875H4.1875ZM6.34766 6.94141C6.07422 7.21484 6.07422 7.625 6.34766 7.87109C6.59375 8.14453 7.00391 8.14453 7.25 7.87109L8.31641 6.80469V10.4688C8.31641 10.8516 8.61719 11.125 8.97266 11.125C9.35547 11.125 9.62891 10.8516 9.62891 10.4688V6.80469L10.6953 7.87109C10.9688 8.14453 11.3789 8.14453 11.625 7.87109C11.8984 7.625 11.8984 7.21484 11.625 6.94141L9.4375 4.75391C9.19141 4.50781 8.78125 4.50781 8.50781 4.75391L6.32031 6.94141H6.34766Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadLight);
export default __webpack_public_path__ + "static/media/upload_light.85446650f6a9bc4c19e2c4f5bb5fb001.svg";
export { ForwardRef as ReactComponent };